import { createFileRoute } from "@tanstack/react-router";
import { AuthRequired } from "@/components/auth/AuthRequired";
import { MembersPage } from "@/components/rank/MembersPage";
import { buildHead } from "@/lib/seo";

// Full-screen league members page (trailing `_` keeps it out of the detail
// layout — it's its own route, not a nested panel).
export const Route = createFileRoute("/_app/rank_/$leagueId_/members")({
  head: ({ params }) =>
    buildHead({ path: `/rank/${params.leagueId}/members`, title: "League members", noindex: true }),
  component: Members,
});

function Members() {
  const { leagueId } = Route.useParams();
  return (
    <AuthRequired>
      <MembersPage leagueId={leagueId} />
    </AuthRequired>
  );
}
